import { Component } from '@angular/core';

@Component({
    selector: 'app-overlay-notifications',
    imports: [],
    templateUrl: './overlay-notifications.component.html',
    styleUrl: './overlay-notifications.component.scss'
})
export class OverlayNotificationsComponent {}
